export const PROPERTY_TYPE_OPTIONS = [
  'Apartment',
  'Villa',
  'Plot',
  'Commercial',
  'Penthouse',
  'Independent House',
  'Studio',
] as const

export const BHK_FILTER_OPTIONS = [
  '1 RK',
  '1 BHK',
  '2 BHK',
  '3 BHK',
  '4 BHK',
  '5 BHK',
  '5+ BHK',
] as const

export const SALE_TYPE_OPTIONS = ['New Bookings', 'Resale'] as const

export const CONSTRUCTION_STATUS_OPTIONS = ['Ready to move', 'Under Construction'] as const

export const PRICE_FILTER_PRESETS = [
  { label: '₹0 - ₹20Cr', min: undefined, max: undefined },
  { label: '₹0 - ₹50 Lac', min: 0, max: 5_000_000 },
  { label: '₹50 Lac - ₹1 Cr', min: 5_000_000, max: 10_000_000 },
  { label: '₹1 Cr - ₹2 Cr', min: 10_000_000, max: 20_000_000 },
  { label: '₹2 Cr - ₹5 Cr', min: 20_000_000, max: 50_000_000 },
  { label: '₹5 Cr - ₹20 Cr', min: 50_000_000, max: 200_000_000 },
] as const

export function formatBudgetCr(amount: number) {
  if (amount >= 10_000_000) {
    const cr = amount / 10_000_000
    return `${cr % 1 === 0 ? cr.toFixed(0) : cr.toFixed(1)}Cr`
  }
  if (amount >= 100_000) return `${Math.round(amount / 100_000)}L`
  return amount.toLocaleString('en-IN')
}

export function getPriceFilterLabel(budgetMin?: number, budgetMax?: number) {
  if (budgetMin == null && budgetMax == null) return '₹0 - ₹20Cr'
  const minLabel = budgetMin != null ? `₹${formatBudgetCr(budgetMin)}` : '₹0'
  const maxLabel = budgetMax != null ? `₹${formatBudgetCr(budgetMax)}` : '₹20Cr+'
  return `${minLabel} - ${maxLabel}`
}
